// ================navbar====================
// Modular Mega Menu Logic
function setupMegaMenu(dropdownContent, defaultTabId) {
  const menuItems = dropdownContent.querySelectorAll(
    ".menu-item[data-submenu]",
  );
  const allSubmenus = dropdownContent.querySelectorAll(".submenu-content");

  function resetItemStyles(item) {
    item.setAttribute("data-active", "false");
    item.classList.remove("bg-purple-50");

    const icon = item.querySelector("svg:first-child");
    const text = item.querySelector("span");
    const arrow = item.querySelector("svg:last-child");

    icon?.classList.remove("text-purple-600");
    icon?.classList.add("text-gray-700");

    text?.classList.remove("text-purple-700", "text-purple-600");
    text?.classList.add("text-gray-700");

    arrow?.classList.remove("text-purple-600");
    arrow?.classList.add("text-gray-400");
  }

  function activateItemStyles(item) {
    item.setAttribute("data-active", "true");
    item.classList.add("bg-purple-50");

    const icon = item.querySelector("svg:first-child");
    const text = item.querySelector("span");
    const arrow = item.querySelector("svg:last-child");

    icon?.classList.remove("text-gray-700");
    icon?.classList.add("text-purple-600");

    text?.classList.remove("text-gray-700");
    text?.classList.add("text-purple-700");

    arrow?.classList.remove("text-gray-400");
    arrow?.classList.add("text-purple-600");
  }

  function setActiveState(submenuId) {
    // Reset all menu items
    menuItems.forEach(resetItemStyles);

    // Hide all submenus
    allSubmenus.forEach((submenu) => {
      submenu.style.display = "none";
    });

    // Activate target item
    const activeItem = dropdownContent.querySelector(
      `.menu-item[data-submenu="${submenuId}"]`,
    );
    if (activeItem) activateItemStyles(activeItem);

    // Show target submenu
    const targetSubmenu = dropdownContent.querySelector(
      `#submenu-${submenuId}`,
    );
    if (targetSubmenu) targetSubmenu.style.display = "block";
  }

  // Initial active state
  setActiveState(defaultTabId);

  // ================= DESKTOP HOVER LOGIC =================
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      if (window.innerWidth < 1024) return;

      const submenuId = item.getAttribute("data-submenu");
      if (submenuId) setActiveState(submenuId);

      // 🔥 Hover color
      const icon = item.querySelector("svg:first-child");
      const text = item.querySelector("span");
      const arrow = item.querySelector("svg:last-child");

      icon?.classList.replace("text-gray-700", "text-purple-600");
      text?.classList.replace("text-gray-700", "text-purple-600");
      arrow?.classList.replace("text-gray-400", "text-purple-600");
    });

    item.addEventListener("mouseleave", () => {
      if (window.innerWidth < 1024) return;

      // 🔥 Reset hover color ONLY if not active
      if (item.getAttribute("data-active") !== "true") {
        const icon = item.querySelector("svg:first-child");
        const text = item.querySelector("span");
        const arrow = item.querySelector("svg:last-child");

        icon?.classList.replace("text-purple-600", "text-gray-700");
        text?.classList.replace("text-purple-600", "text-gray-700");
        arrow?.classList.replace("text-purple-600", "text-gray-400");
      }
    });
  });

  // Reset to default when leaving dropdown (desktop only)
  dropdownContent.addEventListener("mouseleave", () => {
    if (window.innerWidth >= 1024) {
      setActiveState(defaultTabId);
    }
  });
}

// ================= INIT =================
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".dropdown-content").forEach((dropdown) => {
    if (dropdown.querySelector('[data-submenu="ai"]'))
      setupMegaMenu(dropdown, "ai");
    else if (dropdown.querySelector('[data-submenu="lt-ai-services"]'))
      setupMegaMenu(dropdown, "lt-ai-services");
    else if (dropdown.querySelector('[data-submenu="backend"]'))
      setupMegaMenu(dropdown, "backend");
    else if (dropdown.querySelector('[data-submenu="healthcare"]'))
      setupMegaMenu(dropdown, "healthcare");
    else if (dropdown.querySelector('[data-submenu="mobile-apps"]'))
      setupMegaMenu(dropdown, "mobile-apps");
  });
});

// ================= MOBILE MENU =================
const mobileMenuBtn = document.getElementById("mobileMenuBtn");
const mobileMenu = document.getElementById("mobileMenu");

mobileMenuBtn?.addEventListener("click", () => {
  mobileMenu.classList.toggle("hidden");
  const path = mobileMenuBtn.querySelector("svg path");
  path.setAttribute(
    "d",
    mobileMenu.classList.contains("hidden")
      ? "M4 6h16M4 12h16M4 18h16"
      : "M6 18L18 6M6 6l12 12",
  );
});

// ================= MAIN ACCORDION =================
function setupMainAccordion(containerId, btnId, contentId) {
  const btn = document.getElementById(btnId);
  const content = document.getElementById(contentId);
  const container = document.getElementById(containerId);

  if (!btn || !content || !container) return;

  btn.addEventListener("click", () => {
    const isOpen = !content.classList.contains("hidden");

    if (!isOpen) {
      document.querySelectorAll("[data-state='open']").forEach((openBtn) => {
        if (openBtn !== btn) openBtn.click();
      });
    }

    content.classList.toggle("hidden");
    btn.querySelector("svg")?.classList.toggle("rotate-180");

    container.classList.toggle("bg-[#F9F5FF]", !isOpen);
    container.classList.toggle("pb-4", !isOpen);
    container.classList.toggle("p-4", !isOpen);
    btn.setAttribute("data-state", isOpen ? "" : "open");
  });
}

// =================================================
// 🔥 NESTED ACCORDION — FINAL FIX (ONLY ONE OPEN)
// =================================================

let activeNestedAccordion = null;

function setupNestedAccordion(containerId, btnId, contentId) {
  const container = document.getElementById(containerId);
  const btn = document.getElementById(btnId);
  const content = document.getElementById(contentId);

  if (!btn || !content || !container) return;

  btn.addEventListener("click", (e) => {
    e.stopPropagation();

    const isOpen = !content.classList.contains("hidden");

    // 🔒 MOBILE ONLY
    if (window.innerWidth < 1024) {
      // Close previously open nested accordion
      if (activeNestedAccordion && activeNestedAccordion !== content) {
        activeNestedAccordion.classList.add("hidden");
        const prevBtn =
          activeNestedAccordion.previousElementSibling ||
          activeNestedAccordion.parentElement.querySelector("button");
        prevBtn
          ?.querySelector("svg:last-child")
          ?.classList.remove("rotate-180");
        prevBtn?.classList.remove(
          "bg-white",
          "shadow-sm",
          "rounded-t-xl",
          "border-b",
          "border-purple-200",
        );
        activeNestedAccordion.classList.remove(
          "bg-white",
          "rounded-b-xl",
          "shadow-sm",
        );
      }
    }

    // Toggle current
    content.classList.toggle("hidden");
    btn.querySelector("svg:last-child")?.classList.toggle("rotate-180");

    if (!isOpen) {
      activeNestedAccordion = content;
      container.classList.add("mt-2");
      btn.classList.add(
        "bg-white",
        "shadow-sm",
        "rounded-t-xl",
        "border-b",
        "border-purple-200",
      );
      btn.classList.remove("rounded-xl");
      content.classList.add("bg-white", "rounded-b-xl", "shadow-sm");
    } else {
      activeNestedAccordion = null;
      container.classList.remove("mt-2");
      btn.classList.remove(
        "bg-white",
        "shadow-sm",
        "rounded-t-xl",
        "border-b",
        "border-purple-200",
      );
      btn.classList.add("rounded-xl");
      content.classList.remove("bg-white", "rounded-b-xl", "shadow-sm");
    }
  });
}

// Initialize Main Accordions
setupMainAccordion(
  "mobile-lt-ai-container",
  "mobile-lt-ai-btn",
  "mobile-lt-ai-content",
);
// Will initialize others here as they are added
setupMainAccordion(
  "mobile-services-container",
  "mobile-services-btn",
  "mobile-services-content",
);
setupMainAccordion(
  "mobile-hire-container",
  "mobile-hire-btn",
  "mobile-hire-content",
);
setupMainAccordion(
  "mobile-industries-container",
  "mobile-industries-btn",
  "mobile-industries-content",
);
setupMainAccordion(
  "mobile-portfolio-container",
  "mobile-portfolio-btn",
  "mobile-portfolio-content",
);
setupMainAccordion(
  "mobile-company-container",
  "mobile-company-btn",
  "mobile-company-content",
);

// Initialize Nested Accordions
setupNestedAccordion(
  "mobile-ai-services-container",
  "mobile-ai-services-btn",
  "mobile-ai-services-content",
);
setupNestedAccordion(
  "mobile-ai-solutions-container",
  "mobile-ai-solutions-btn",
  "mobile-ai-solutions-content",
);

// Services Nested Accordions
setupNestedAccordion(
  "mobile-services-ai-container",
  "mobile-services-ai-btn",
  "mobile-services-ai-content",
);
setupNestedAccordion(
  "mobile-services-mobile-container",
  "mobile-services-mobile-btn",
  "mobile-services-mobile-content",
);
setupNestedAccordion(
  "mobile-services-web-container",
  "mobile-services-web-btn",
  "mobile-services-web-content",
);
setupNestedAccordion(
  "mobile-services-design-container",
  "mobile-services-design-btn",
  "mobile-services-design-content",
);
setupNestedAccordion(
  "mobile-services-cloud-container",
  "mobile-services-cloud-btn",
  "mobile-services-cloud-content",
);
setupNestedAccordion(
  "mobile-services-emerging-container",
  "mobile-services-emerging-btn",
  "mobile-services-emerging-content",
);
setupNestedAccordion(
  "mobile-services-qa-container",
  "mobile-services-qa-btn",
  "mobile-services-qa-content",
);
setupNestedAccordion(
  "mobile-services-data-container",
  "mobile-services-data-btn",
  "mobile-services-data-content",
);

setupNestedAccordion(
  "mobile-services-cyberSecurity-container",
  "mobile-services-cyberSecurity-btn",
  "mobile-services-cyberSecurity-content",
);

// Hire Talent Nested Accordions
setupNestedAccordion(
  "mobile-hire-backend-container",
  "mobile-hire-backend-btn",
  "mobile-hire-backend-content",
);
setupNestedAccordion(
  "mobile-hire-frontend-container",
  "mobile-hire-frontend-btn",
  "mobile-hire-frontend-content",
);
setupNestedAccordion(
  "mobile-hire-mobile-container",
  "mobile-hire-mobile-btn",
  "mobile-hire-mobile-content",
);

setupNestedAccordion(
  "mobile-hire-database-container",
  "mobile-hire-database-btn",
  "mobile-hire-database-content",
);

setupNestedAccordion(
  "mobile-hire-infra-container",
  "mobile-hire-infra-btn",
  "mobile-hire-infra-content",
);

setupNestedAccordion(
  "mobile-hire-quality-container",
  "mobile-hire-quality-btn",
  "mobile-hire-quality-content",
);

setupNestedAccordion(
  "mobile-hire-design-container",
  "mobile-hire-design-btn",
  "mobile-hire-design-content",
);

// Industries Nested Accordions
setupNestedAccordion(
  "mobile-industries-healthcare-container",
  "mobile-industries-healthcare-btn",
  "mobile-industries-healthcare-content",
);
setupNestedAccordion(
  "mobile-industries-fintech-container",
  "mobile-industries-fintech-btn",
  "mobile-industries-fintech-content",
);
setupNestedAccordion(
  "mobile-industries-ecommerce-container",
  "mobile-industries-ecommerce-btn",
  "mobile-industries-ecommerce-content",
);

// Portfolio Nested Accordions
setupNestedAccordion(
  "mobile-portfolio-mobile-container",
  "mobile-portfolio-mobile-btn",
  "mobile-portfolio-mobile-content",
);
setupNestedAccordion(
  "mobile-portfolio-web-container",
  "mobile-portfolio-web-btn",
  "mobile-portfolio-web-content",
);
setupNestedAccordion(
  "mobile-portfolio-uiux-container",
  "mobile-portfolio-uiux-btn",
  "mobile-portfolio-uiux-content",
);

// =============
// =================
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth >= 1024) return;

  const triggers = document.querySelectorAll(".footer-accordion-trigger");

  triggers.forEach((trigger) => {
    const content = trigger.nextElementSibling;

    trigger.addEventListener("click", () => {
      const isOpen = content.classList.contains("open");

      document
        .querySelectorAll(".footer-accordion-content")
        .forEach((el) => el.classList.remove("open"));
      document
        .querySelectorAll(".footer-accordion-trigger")
        .forEach((el) => el.classList.remove("active"));

      if (!isOpen) {
        content.classList.add("open");
        trigger.classList.add("active");
      }
    });
  });
});
